import { IViewAccessibility } from './interfaces/view-accessibility.interface';

export class ViewAccessibilityChangeEvent {
    public constructor(
        public userId: string,
        public viewsAccessibilities: IViewAccessibility[]
    ) {}
}
